import React from "react";

export const CartIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none">
      <path
        d="M4.5 20.5C4.5 21.0304 4.71071 21.5391 5.08579 21.9142C5.46086 22.2893 5.96957 22.5 6.5 22.5C7.03043 22.5 7.53914 22.2893 7.91421 21.9142C8.28929 21.5391 8.5 21.0304 8.5 20.5M11.5 20.5C11.5 21.0304 11.7107 21.5391 12.0858 21.9142C12.4609 22.2893 12.9696 22.5 13.5 22.5C14.0304 22.5 14.5391 22.2893 14.9142 21.9142C15.2893 21.5391 15.5 21.0304 15.5 20.5M6 7H21.5V7.25L21.261 7.533C18.8317 10.418 17.4997 14.0684 17.5 17.84V18H4.5V16.12C4.5 14.04 4.434 11.962 4.114 9.908C3.56 6.352 2.337 1 0 1"
        stroke="black"
        stroke-width="1.2"
      />
    </svg>
  );
};
